export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11226_SIGN_IN_WITH_MICROSOFT': 'Sign in with Microsoft',
    '_11227_PLEASE_ENSURE_THAT_POPUPS_ARE_NOT_BLOCKED_': 'Please ensure that popups are not blocked.'
};
